import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import MetaDataService from "../../services/MetaDataService";
import CustomButton from "../CustomButton";
import classes from "./contactSales.module.css";
import ContactSalesForm from "./ContactSalesForm";
import ContactSalesFormV2 from "./ContactSalesFormV2";
import Snackbar from "../Snackbar";
import MobileDesktopModalWrapper from "../MobileDesktopModalWrapper";
import LogService from "../../services/LogService";
import CREDIT_EVENTS from "../../utils/CreditEvents";
import cx from "classnames";
import { isMobileDevice } from "../../services/utils";
import { useContactSalesABTest } from "../../hooks/useABTest";
import { JhPopupDrawer } from "designPackages/popupPackage";

const ContactSales = props => {
  const {
    mainTitle = "",
    mainSubTitle = "",
    customClass = null,
    source,
    ctaLabel = "Contact sales",
    planSelection = false,
    openings = ""
  } = props;
  const [openModel, setModal] = useState(false);
  const snackbar = useSelector(state => state.snackbarReducer);
  const { shouldShowV2Form } = useContactSalesABTest();
  const [salesContact, setSalesContactData] = useState({
    title: "",
    subTitle: "",
    phone: "",
    email: "",
    workingTime: ""
  });

  useEffect(() => {
    const getSalesContact = async () => {
      const data = await MetaDataService.getCreditInfo();
      setSalesContactData(prevState => ({
        ...data.data,
        ...(mainTitle && { title: mainTitle }),
        ...(mainTitle && { subTitle: mainSubTitle })
      }));
    };
    getSalesContact();
  }, []);

  function onClick() {
    // Use centralized A/B test logic for event logging
    if (shouldShowV2Form) {
      LogService.log(CREDIT_EVENTS.CONTACT_SALES_CLICKED_V2);
    } else {
      LogService.log(CREDIT_EVENTS.CREDIT_SELECTION_CONTACT_SALES_CLICKED);
    }

    setModal(true);
  }

  function handleClose(isClosedClicked = false) {
    if (isClosedClicked)
      LogService.log(CREDIT_EVENTS.SALES_POP_UP_DISMISS_CLICKED);
    setModal(false);
  }
  const { title, subTitle } = salesContact;
  const isMobile = isMobileDevice();

  return (
    <div className={cx(customClass, classes.root)}>
      {planSelection ? (
        <div className={classes.planSelection}>
          <div className={classes.left}>
            <img src="/hire/sales-call.svg" alt="call" width={20} height={20} />
            <div className={classes.title}>
              {title}
              <span className={classes.subTitle}>{subTitle}</span>
            </div>
          </div>
          <CustomButton className={classes.contactButton} onClick={onClick}>
            {ctaLabel}
          </CustomButton>
        </div>
      ) : (
        <>
          <div className={classes.left}>
            <img
              src="/hire/sales-call.svg"
              alt="call"
              width={isMobile ? 28 : 40}
              height={isMobile ? 28 : 40}
            />
            <div className={classes.title}>
              {title}
              <span className={classes.subTitle}>{subTitle}</span>
            </div>
          </div>
          <div className={classes.right}>
            <CustomButton className={classes.contactButton} onClick={onClick}>
              {ctaLabel}
            </CustomButton>
          </div>
        </>
      )}

      {openModel ? (
        <>
          {shouldShowV2Form ? (
            <JhPopupDrawer
              open={openModel}
              onClose={handleClose}
              position={"center"}
              className="tw-root"
            >
              <ContactSalesFormV2
                closeModal={handleClose}
                salesContact={salesContact}
                source={source}
                rootMargin={false}
              />
            </JhPopupDrawer>
          ) : (
            <MobileDesktopModalWrapper
              handleModalToggle={() => handleClose(true)}
              isCloseButton={!shouldShowV2Form} // Hide default close button for V2 (it has its own)
            >
              <ContactSalesForm
                closeModal={handleClose}
                salesContact={salesContact}
                source={source}
                openings={openings}
              />
            </MobileDesktopModalWrapper>
          )}
        </>
      ) : null}

      {snackbar.snackBarState || snackbar.snackBarSuccessState ? (
        <Snackbar />
      ) : null}
    </div>
  );
};
export default ContactSales;
